import Button from '@/components/Button';
import { useMissionStore } from '../../../shared/store/useMissionStore';
import { useNavigate } from 'react-router-dom';
import { useAssessmentStore } from '../../store/useAssessmentStore';

interface YouHaventFilledPreAssessmentProps {
  selectedCohortId?: string;
}

export const YouHaventFilledPreAssessment = ({ selectedCohortId }: YouHaventFilledPreAssessmentProps) => {
  const navigate = useNavigate();
  const mission = useMissionStore((state) => state.mission);
  const assessmentPage = useAssessmentStore((state) => state.assessmentPage);
  const cohorts = useAssessmentStore((state) => state.cohorts);

  const selectedCohort = cohorts?.find((c) => c.documentId === selectedCohortId);

  const onPress = () => {
    navigate(
      `/mission/${mission?.slug}/chapter/${encodeURIComponent(mission?.chapters?.[0]?.title || '')}/assessment?from=${encodeURIComponent(mission?.chapters?.[mission?.chapters?.length - 1]?.title || '')}`,
    );
  };

  return (
    <div className="my-5 rounded-2xl bg-primary-300 p-5">
      <div className="flex flex-col gap-4">
        <div className="flex items-center gap-2">
          {assessmentPage?.youHaventFilledPre?.icon?.url && (
            <img src={assessmentPage.youHaventFilledPre.icon.url} alt="Icon" className="h-6 w-6" />
          )}
          <h3 className="!my-0 font-cadiz text-sh-md font-bold text-black">
            {assessmentPage?.youHaventFilledPre?.title}
          </h3>
        </div>
        <div className="flex flex-col gap-3">
          <p className="text-sm leading-6 text-gray-700">
            {selectedCohort
              ? `${assessmentPage?.youHaventFilledPre?.description} for cohort "${selectedCohort.name}"`
              : assessmentPage?.youHaventFilledPre?.description}
          </p>
          <Button theme="solid" onClick={onPress} className="mt-2 self-start">
            {assessmentPage?.youHaventFilledPre?.cta}
          </Button>
        </div>
      </div>
    </div>
  );
};
